import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from './componenets/PageHero';
import Reveal from './componenets/Reveal';

export const Volunteering = () => (
  <div className="site-page">
    <PageHero eyebrow="Get involved" title="Volunteer with Garden of Peace" description="Volunteer your time and skills to support the cemetery and its services." image="/images/HomeSlider_8.jpg" compact />
    <section className="site-section"><div className="site-container resource-layout">
      <Reveal className="resource-layout__copy"><p className="site-eyebrow">Volunteer</p><h2>Volunteer Opportunities</h2><p>We welcome compassionate community members who want to help with outreach, events, administration, property preparation, and family support.</p><p>No matter your experience, there may be a meaningful way for you to contribute.</p><Link className="site-button" to="/contactus">Contact us to volunteer</Link></Reveal>
      <Reveal className="resource-poster" delay={100}><img src="/images/Volunteer_Message.jpg" alt="Garden of Peace volunteer information" /></Reveal>
    </div></section>
  </div>
);
